/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './TabComponent.css'; // Import a CSS file for styling
import { awsServer } from '../../../../utilities/UrlPaths';
import LotDetailsContainer from '../LotDetails/LotDetailsContainer';
import ShippingDetailsModal from '../ShippingDetailsModal/ShippingDetailsModal';
import ConfirmModal from '../../../../utilities/form-components/ConfirmModal';
import { updateShippingReviewData } from '../../../../modules/shippingReview/thunks';

const TabComponent = ({ activeTab, onClickTab }) => {
  const dispatch = useDispatch();
  const [isEditShippingModalOpen, setIsEditShippingModalOpen] = useState(false);
  const [lotData, setLotData] = useState({});
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [deletionConfirmed, setDeletionConfirmed] = useState(false);

  const {
    shippingItemCountAll,
    readyToConfirmCount,
    needsReviewCount,
  } = useSelector((state) => state.shippingReview);

  const openEditShippingModal = (lotInfo) => {
    setLotData(lotInfo);
    setIsEditShippingModalOpen(true);
  };

  const onCloseModal = () => {
    setIsEditShippingModalOpen(false);
    setLotData({});
  };

  const onSubmitReview = (lotId, reviewID, houseID, payload) => {
    dispatch(updateShippingReviewData(reviewID, houseID, payload));
  };

  const onCloseDeleteModal = () => {
    setShowConfirmDeleteModal(false);
  };

  const onConfirmDelete = () => {
    setDeletionConfirmed(true);
    setShowConfirmDeleteModal(false);
  };

  const tabs = [
    { name: 'All', count: shippingItemCountAll },
    { name: 'Ready To Confirm', count: readyToConfirmCount },
    { name: 'Needs Review', count: needsReviewCount },
  ];

  // Function to render content based on the active tab
  const renderContent = () => {
    switch (activeTab) {
      case 'All':
        return <LotDetailsContainer filterSelected="all" openEditShippingModal={openEditShippingModal} onConfirm={onSubmitReview} />;
      case 'Ready To Confirm':
        return <LotDetailsContainer filterSelected="readyToConfirm" openEditShippingModal={openEditShippingModal} onConfirm={onSubmitReview} />;
      case 'Needs Review':
        return <LotDetailsContainer filterSelected="needsReview" openEditShippingModal={openEditShippingModal} onConfirm={onSubmitReview} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="tab-container">
        {tabs.map((tab) => (
          <div
            key={tab.name}
            className={`tab ${activeTab === tab.name ? 'active' : ''}`}
            onClick={() => onClickTab(tab.name)}
          >
            {(tab.name === 'Needs Review' && needsReviewCount > 0)
            && <img className="pr-1" src={`${awsServer}/static/error-bubble.svg`} alt="error bubble" />}
            {tab.name} ({tab.count})
          </div>
        ))}
        <div className="total-items">
          {shippingItemCountAll} Lots
        </div>
      </div>
      <div className="lot-details-content">
        {renderContent()}
        <ShippingDetailsModal
          isOpen={isEditShippingModalOpen}
          fade
          centered
          lotData={lotData}
          close={onCloseModal}
          onSave={onSubmitReview}
          setShowDeleteModal={setShowConfirmDeleteModal}
          deletionConfirmed={deletionConfirmed}
          setDeletionConfirmed={setDeletionConfirmed}
        />
        <ConfirmModal
          actionFunction={onConfirmDelete}
          buttonText="Delete"
          bodyText="This action cannot be undone once you select Delete"
          showModal={showConfirmDeleteModal}
          title="Delete Object?"
          toggleFunction={onCloseDeleteModal}
        />
      </div>
    </>
  );
};

export default TabComponent;
